import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from 'src/Components/Button'

const propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

const showCopy = () => (
  <FormattedMessage id='ToggleSection.show' defaultMessage='Show more' />
)

const hideCopy = () => (
  <FormattedMessage id='ToggleSection.hide' defaultMessage='Show less' />
)

const ToggleSection = ({ show, setShow, useVisibility, children }) => (
  <Fragment>
    <section style={{ display: show ? 'block' : 'none' }}>{children}</section>
    <Button
      minimal
      onClick={e => {
        e.preventDefault()
        setShow(!show)
      }}
    >
      {show ? hideCopy() : showCopy()}
    </Button>
  </Fragment>
)

ToggleSection.propTypes = propTypes

export default ToggleSection
